import { useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  getPayoutSummary,
  GetPayoutSummaryResponse,
} from 'api/payments/getPayoutSummary'

export function usePayoutSummary(
  paymentId: number | null | undefined,
  options?: {
    enabled?: boolean
  }
): UseQueryResult<GetPayoutSummaryResponse> {
  return useQuery({
    queryKey: ['payoutSummary', paymentId],
    queryFn: () => getPayoutSummary(paymentId!),
    enabled: (options?.enabled ?? true) && paymentId != null,
    retry: false,
  })
}
